import config from '../config'
import { authRequest } from '../request'

const base = `${config.mainApi}/benefit-platforms`

export type BenefitPlatform = {
  id: number
  code: string
  name: string
  clientCredentialId: number
  clientId: string
  integrationType: 'SANDBOX'
  cashCentsPerCredit: number
  subsidyType: 'NONE' | 'PERCENTAGE' | 'FIXED_CENTS'
  subsidyValue: number
  paymentMode: 'USER_PAY' | 'FULLY_COVERED'
  enabled: boolean
}

export type BenefitPlatformCreate = Omit<BenefitPlatform, 'id' | 'enabled' | 'clientId'>

export type BenefitPlatformUpdate = Pick<
  BenefitPlatform,
  | 'name'
  | 'clientCredentialId'
  | 'cashCentsPerCredit'
  | 'subsidyType'
  | 'subsidyValue'
  | 'paymentMode'
  | 'enabled'
>

export type BenefitPlatformCredentialOption = {
  id: number
  clientId: string
  name: string
  isBlocked: boolean
}

export const listBenefitPlatformCredentials = () =>
  authRequest.get<MISSING_TYPE, BenefitPlatformCredentialOption[]>(`${base}/client-credentials`)

export const listBenefitPlatforms = () => authRequest.get<MISSING_TYPE, BenefitPlatform[]>(base)

export const createBenefitPlatform = (data: BenefitPlatformCreate) =>
  authRequest.post<MISSING_TYPE, BenefitPlatform>(base, data)

export const updateBenefitPlatform = (id: number, data: BenefitPlatformUpdate) =>
  authRequest.put<MISSING_TYPE, BenefitPlatform>(`${base}/${id}`, data)
